import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import AddScheduledDowntime from './submodules/create';
import ListScheduledDowntime from './submodules/list';
import UpdateScheduledDowntime from './submodules/edit';

const CouponDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.scheduledDowntime}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.scheduledDowntime].listScheduledDowntime]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListScheduledDowntime}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.scheduledDowntime}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.scheduledDowntime].updateScheduledDowntime]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/edit`}
				component={UpdateScheduledDowntime}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.scheduledDowntime}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.scheduledDowntime].addScheduledDowntime]}
				path={`${path}/create`}
				configPageName={PAGE_NAMES.dashboard}
				component={AddScheduledDowntime}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default CouponDashboard;
